import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface SyncPreviewResponse {
  filesWithoutMetadata: number;
  filesWithMetadata: number;
  sampleFiles: Array<{ id: string; name: string; controlNumber: string }>;
  fieldMappingConfigured: boolean;
}

interface UseGetRelativitySyncPreviewOptions {
  enabled?: boolean;
  includeExisting?: boolean;
}

const useGetRelativitySyncPreview = (
  matterId: string | undefined,
  workspaceId: number | undefined,
  options: UseGetRelativitySyncPreviewOptions = {},
) => {
  const { enabled = true, includeExisting = false } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getSyncPreview = async (): Promise<SyncPreviewResponse> => {
    const url = `${APIBaseChronos}/api/relativity/sync/preview?matterId=${matterId}&workspaceId=${workspaceId}&includeExisting=${includeExisting}`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch sync preview: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery(
    [QueryEntity.RelativitySyncPreview, matterId, workspaceId, includeExisting],
    getSyncPreview,
    {
      enabled: enabled && !!matterId && !!workspaceId,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
};

export default useGetRelativitySyncPreview;
